import { PieChart } from "@element-plus/icons-vue";

export default {
  selection: true,
  columns: [
    // 表格列的配置
    {
      label: "订单号",
      prop: "ord_no",
      fixed: true,
    },
    {
      label: "签约日期",
      prop: "create_time",
    },
    {
      label: "客户",
      prop: "cst_id_v",
    },
    {
      label: "归属人",
      prop: "user_id_v",
    },
    {
      label: "订单状态",
      prop: "ord_status_v",
    },
    {
      label: "订单备注",
      prop: "ord_remark",
    },
  ],
};
